class FilterManagerSingleton {
	subscriptions = [];

	hideOtherFilters = id => {
		this.subscriptions.filter(subscription => subscription.id !== id).forEach(subscription => {
			subscription.hide();
		});
	};

	hideAllFilters = () => {
		this.subscriptions.forEach(subscription => {
			subscription.hide();
		});
	};

	subscribe = subscription => {
		this.subscriptions.push(subscription);
	};

	unsubscribe = id => {
		this.subscriptions = this.subscriptions.filter(subscription => subscription.id !== id);
	};
}

export const FilterManager = new FilterManagerSingleton();



// WEBPACK FOOTER //
// ./src/managers/filterManager.js